import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import {
  ICreateSubmissionInput,
  ISubmission,
  ISubmissionOverviews,
  TSubmitters,
} from 'types/submissions'

export const submissionApi = createApi({
  reducerPath: 'submissions',
  baseQuery,
  tagTypes: ['Submission', 'MySubmissions', 'Submitters', 'SubmissionsOverview'],
  endpoints: (builder) => ({
    submissionsOverview: builder.query<ISubmissionOverviews, { lotId: string }>({
      query: ({ lotId }) => {
        return {
          url: '/submissions/overview',
          method: 'get',
          params: {
            lotId,
          },
        }
      },
      providesTags: ['SubmissionsOverview'],
    }),

    submitters: builder.query<TSubmitters, { lotId: string }>({
      query: ({ lotId }) => {
        return {
          url: '/submissions/submitters',
          method: 'get',
          params: {
            lotId,
          },
        }
      },
      providesTags: ['Submitters'],
    }),

    mySubmissions: builder.query<ISubmission, { lotId: string }>({
      query: ({ lotId }) => {
        return {
          url: '/submissions/my-submission',
          method: 'get',
          params: {
            lotId,
          },
        }
      },
      providesTags: ['MySubmissions'],
    }),

    submission: builder.query<ISubmission, { submissionId: string }>({
      query: ({ submissionId }) => {
        return {
          url: `/submissions/${submissionId}`,
          method: 'get',
        }
      },
      providesTags: ['Submission'],
    }),

    createSubmission: builder.mutation<void, ICreateSubmissionInput>({
      query: (body) => ({
        url: `/submissions`,
        body,
        method: 'post',
      }),
      invalidatesTags: ['SubmissionsOverview', 'Submission'],
    }),

    submitSubmission: builder.mutation<void, { submissionId: string }>({
      query: ({ submissionId }) => ({
        url: `/submissions/${submissionId}/submit`,
        method: 'post',
      }),
      invalidatesTags: ['SubmissionsOverview', 'Submission', 'MySubmissions'],
    }),
  }),
})

export const {
  useSubmissionsOverviewQuery,
  useSubmissionQuery,
  useCreateSubmissionMutation,
  useMySubmissionsQuery,
  useSubmittersQuery,
  useSubmitSubmissionMutation,
} = submissionApi
